import { render, staticRenderFns } from "./vendor-top-list.vue?vue&type=template&id=2d00290a&scoped=true&"
import script from "./vendor-top-list.vue?vue&type=script&lang=js&"
export * from "./vendor-top-list.vue?vue&type=script&lang=js&"
import style0 from "./vendor-top-list.vue?vue&type=style&index=0&id=2d00290a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00290a",
  null
  
)

export default component.exports